<template>
  <div v-click-outside="hideSidebar" class="sidebar" :class="{ open: showTopMenu }">
    <div class="mobile-header">
      <div :class="{ active: showTopMenu }" class="hamburger" @click="showTopMenu = !showTopMenu">
        <div>
          <span class="line" />
          <span class="line" />
          <span class="line" />
        </div>
      </div>
    </div>
    <nav role="navigation" class="menu__wrapper" @mouseleave="hideSubMenu">
      <BoxComponent :mb="32" :mr="16" :ml="15" class="sidebar__logo-container">
        <router-link to="/" class="sidebar-logo__container">
          <LogoIcon class="sidebar__logo" />
        </router-link>
      </BoxComponent>
      <div class="menu__container">
        <ul class="menu">
          <template v-for="(item, index) in navLinkList">
            <li v-if="item.condition" :key="`nav_item_${index}`" class="menu-item">
              <div v-if="typeof item.onboardingId === 'string'" :id="item.onboardingId" />
              <div v-else>
                <div v-for="id in item.onboardingId" :id="id" :key="id" />
              </div>
              <!-- @vue-expect-error todo fix me -->
              <router-link
                :to="{ name: item.path, params: { ...item.params } }"
                class="menu-item__link"
                aria-current="page"
                aria-expanded="false"
                @click="item.action"
              >
                <div class="menu-item__link-container">
                  <div
                    :class="{
                      'menu-item__icon-wrapper': true,
                      'is-active-onboarding-step': isOnboardingActive && item.isActiveOnboardingStep,
                    }"
                  >
                    <img class="menu-item__icon" :src="item.icon" :alt="item.alt" />
                  </div>
                  <span class="menu-item__label">{{ item.title }}</span>
                </div>
              </router-link>
            </li>
          </template>
        </ul>
        <ul class="menu">
          <li class="menu-item">
            <div class="menu-item__link" @click="toggleAccountMenu">
              <div class="menu-item__link-container">
                <img :src="settingsItem.icon" :alt="settingsItem.alt" />
                <span class="menu-item__label">{{ settingsItem.title }}</span>
                <img class="menu-item__dot" src="../assets/sidebar/more.svg" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="submenu-popup" :class="{ active: isAccountMenuVisible }">
        <div class="submenu-popup__title">{{ settingsItem.title }}</div>
        <ul class="submenu">
          <template v-for="(item, index) in settingsItem.subMenu">
            <li v-if="item.condition" :key="`sub_item_${index}`" class="submenu-item">
              <!-- @vue-expect-error todo fix me -->
              <router-link
                v-if="item.path"
                :to="{ name: item.path, params: { ...item.params } }"
                aria-current="page"
                class="submenu-item__link"
              >
                <img :src="item.icon" :alt="item.alt" />
                <span class="submenu-item__label">{{ item.title }}</span>
              </router-link>
              <!-- @vue-expect-error todo fix me -->
              <a v-else class="submenu-item__link" @click="item.click">
                <img :src="item.icon" :alt="item.alt" />
                <span class="submenu-item__label">{{ item.title }}</span>
              </a>
            </li>
          </template>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script lang="ts">
import { useFlag } from '@unleash/proxy-client-vue'
import { mapStores } from 'pinia'
import { mapGetters, mapState } from 'vuex'

import LogoIcon from '@/assets/icons/metapic-icon-black.svg?component'
import CampaignImg from '@/assets/sidebar/campaign.svg'
import ChannelImg from '@/assets/sidebar/channel.svg'
import InvoiceImg from '@/assets/sidebar/invoice.svg'
import LogoutImg from '@/assets/sidebar/logout.svg'
import CostImg from '@/assets/sidebar/money.svg'
import MyStoreImg from '@/assets/sidebar/my-store.svg'
import OverviewImg from '@/assets/sidebar/overview.svg'
import PostImg from '@/assets/sidebar/post.svg'
import SaleImg from '@/assets/sidebar/sale.svg'
import SegmentsImg from '@/assets/sidebar/segments.svg'
import SettingsImg from '@/assets/sidebar/settings.svg'
import { FLAG_CHANNELS, FLAG_SEGMENTS } from '@/lib/constants/flags'
import { PAGE_NAME_MAPPING } from '@/lib/helpers/navigation.helpers'
import { useEntrypointStore } from '@/stores/entrypoint.stores'
import { AdvertiserVisibility } from '@/types'
import BoxComponent from '@/ui-library/atoms/BoxComponent/BoxComponent.vue'
export default {
  name: 'Sidebar',
  components: { BoxComponent, LogoIcon },
  middleware: 'auth',
  setup() {
    return {
      isChannelsEnabled: useFlag(FLAG_CHANNELS),
      isSegmentsEnabled: useFlag(FLAG_SEGMENTS),
    }
  },
  data: () => ({
    showTopMenu: false,
    isAccountMenuVisible: false,
  }),
  computed: {
    ...mapGetters('shop', [
      'shop',
      'hideCosts',
      'hideEdit',
      'hideMedia',
      'hideFindInfluencers',
      'hideSales',
      'hideUsers',
      'hideClicks',
      'isDirectStore',
      'hidden',
    ]),
    ...mapStores(useEntrypointStore),
    ...mapState('onboarding', ['showOnboardingDashboard']),
    isOnboardingActive() {
      return this.showOnboardingDashboard && this.isDirectStore
    },
    navLinkList() {
      return [
        {
          path: 'overview',
          title: PAGE_NAME_MAPPING.overview,
          icon: OverviewImg,
          alt: 'Overview image',
          condition: !this.hideClicks,
        },
        {
          path: this.isChannelsEnabled ? 'channels' : 'channel',
          params: this.isChannelsEnabled ? { tab: 'creators' } : {},
          title: this.isChannelsEnabled ? PAGE_NAME_MAPPING.channels : PAGE_NAME_MAPPING.channel,
          icon: ChannelImg,
          alt: 'Channel image',
          condition: !this.hideUsers,
        },
        {
          path: 'segments',
          title: PAGE_NAME_MAPPING.segments,
          icon: SegmentsImg,
          condition: this.isSegmentsEnabled && !this.hideUsers && !this.hideEdit,
          alt: 'Segments image',
        },
        {
          path: 'orders',
          title: PAGE_NAME_MAPPING.orders,
          icon: SaleImg,
          alt: 'Orders image',
          condition: !this.hideSales,
          onboardingId: 'order-sales-menu-section',
          isActiveOnboardingStep: this.$store.getters['onboarding/currentOnboardingStep'] === 1,
        },
        {
          path: 'content-library',
          title: PAGE_NAME_MAPPING.contentLibrary,
          icon: PostImg,
          condition: !this.hideMedia,
          alt: 'Content Library',
        },
        {
          path: 'costs',
          title: PAGE_NAME_MAPPING.costs,
          icon: CostImg,
          alt: 'Costs image',
          condition:
            !this.hideCosts &&
            !this.hideEdit &&
            [AdvertiserVisibility.ALL_USERS, AdvertiserVisibility.ALL_VERIFIED_USERS].includes(this.hidden),
        },
        {
          path: 'campaigns',
          title: PAGE_NAME_MAPPING.campaigns,
          icon: CampaignImg,
          alt: 'Campaigns image',
          condition: !this.hideEdit || this.entrypointStore.hasCampaigns,
          onboardingId: ['campaign-menu-section', 'manage-campaign-menu-section'],
          isActiveOnboardingStep:
            this.$store.getters['onboarding/currentOnboardingStep'] === 2 || this.$store.getters['onboarding/currentOnboardingStep'] === 3,
        },
        {
          path: 'invoices',
          title: PAGE_NAME_MAPPING.invoices,
          icon: InvoiceImg,
          alt: 'Invoices image',
          condition: this.entrypointStore.hasInvoices,
        },
      ]
    },
    settingsItem() {
      return {
        title: 'My Store',
        icon: MyStoreImg,
        alt: 'My Store image',
        subMenu: [
          {
            path: 'edit-advertiser',
            title: PAGE_NAME_MAPPING.settings,
            icon: SettingsImg,
            alt: 'Store settings image',
            condition: true,
          },
          {
            path: 'logout',
            title: PAGE_NAME_MAPPING.logout,
            icon: LogoutImg,
            alt: 'Logout image',
            condition: true,
          },
        ],
      }
    },
  },
  watch: {
    $route: function () {
      this.showTopMenu = false
      this.isAccountMenuVisible = false
    },
  },

  mounted() {
    if (this.$store.getters['onboarding/currentOnboardingStep'] === 0) {
      this.$store.dispatch('onboarding/setCurrentCard', 'order-sales-menu-section')
      this.$store.dispatch('onboarding/setCurrentStep', 1)
      this.$store.dispatch('onboarding/setOnboardingActivity', true)
    }
  },

  methods: {
    toggleAccountMenu() {
      this.isAccountMenuVisible = !this.isAccountMenuVisible
    },

    hideSubMenu() {
      this.isAccountMenuVisible = false
    },
    hideSidebar() {
      this.showTopMenu = false
      this.isAccountMenuVisible = false
    },
    getLinkOrderInList(n) {
      let cnt = n
      for (let i = 0; i < n; i++) {
        if (!this.navLinkList[i].condition) {
          cnt = cnt - 1
        }
      }
      return cnt
    },
  },
}
</script>
<style lang="scss" scoped>
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
}

.sidebar__logo-container {
  width: 48px;
  height: 48px;
  overflow: hidden;
  flex: 0 0 48px;
}
.sidebar__logo {
  width: 48px;
  height: 48px;
}

.menu__wrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.menu__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.menu {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.menu-item {
  position: relative;
  transition: width 0.2s ease;
}

.menu-item__link {
  width: 100%;
  cursor: pointer;
  text-decoration: none;

  .menu-item__link-container {
    display: flex;
    gap: 12px;
    align-items: center;
    border-radius: 8px;
    padding: 20px 12px 20px 20px;
    margin: 0 8px;
    font-size: 14px;
    line-height: 20px;
    transition: background-color 0.23s ease;

    &:hover {
      background: var(--black04);
    }
  }

  &.router-link-exact-active {
    .menu-item__link-container {
      background: var(--black04);
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;

      width: 4px;
      height: 64px;

      border-radius: 8px;
      background: var(--primary);
    }
  }
}

.menu-item__label {
  color: var(--primary);
  font-weight: 500;
  white-space: nowrap;
  font-size: 14px;
  line-height: 20px;
}

.menu-item__icon-wrapper {
  position: relative;

  &.is-active-onboarding-step::before {
    content: '';
    display: block;
    position: absolute;
    top: -8px;
    left: -8px;
    width: 40px;
    height: 40px;
    border: 2px solid #439fd2;
    border-radius: 50%;
  }
}

.menu-item__icon {
  width: 24px;
  height: 24px;
}

.menu-item__label,
.menu-item__dot {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.menu-item__dot {
  margin-left: auto;
}

.submenu-popup {
  display: none;
  position: absolute;
  bottom: 8px;
  left: calc(100% - 16px);
  min-width: 150px;
  border-radius: 16px;
  padding: 8px 0;
  background: var(--white);
  box-shadow: -1px 4px 18px 0px rgba(161, 161, 161, 0.19);

  &.active {
    display: block;
  }
}

.submenu {
  padding: 0;
  margin: 0;
}

.submenu-popup__title {
  padding: 8px 16px;
  font-size: 16px;
  line-height: 24px;
  color: var(--primary);
}

.submenu-item {
  padding: 0;
  list-style: none;

  &:first-child {
    border-bottom: 1px solid rgba(3, 30, 81, 0.12);
  }
}

.submenu-item__link {
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
  padding: 16px;
  margin: 0;
  text-decoration: none;

  &:hover,
  &.router-link-exact-active {
    background: var(--invertedLight);
  }
}

.submenu-item__label {
  color: var(--primary);
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  white-space: nowrap;
}

.hamburger {
  background: var(--white);
  border-right: 1px solid #eee;
  cursor: pointer;
  position: absolute;
  height: 64px;
  width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.4s;

  .line {
    width: 18px;
    height: 2px;
    background-color: var(--primary);
    display: block;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;

    &:nth-child(2) {
      margin: 4px auto;
    }

    &:last-child {
      width: 10px;
      margin-right: 8px;
    }
  }

  &.active {
    border-right-color: transparent;
    right: 0;
    top: 0;
  }

  &.active > div {
    transition: all 0.3s ease-in-out;
    transition-delay: 0.15s;
    transform: rotate(45deg);
  }

  &.active .line:nth-child(3) {
    margin: 0;
    width: 0;
  }

  &.active .line:nth-child(1),
  &.active .line:nth-child(2) {
    transition-delay: 0.15s;
    border-radius: 0;
  }

  &.active .line:nth-child(1) {
    transform: translateY(0px);
  }

  &.active .line:nth-child(2) {
    transform: translateY(-6px) rotate(90deg);
  }
}

@include media-breakpoint-down(lg) {
  .sidebar {
    position: absolute;
    width: 0;

    .menu__wrapper {
      overflow: hidden;
    }
  }

  .sidebar.open {
    position: fixed;
    display: flex;
    flex-direction: column;
    height: 100vh;
    height: 100dvh;
    width: 240px;

    transition: width ease 0.2s;
    padding: 32px 0 16px;
    border-right: 1px solid #eee;
    background: var(--white);
    box-shadow: 2px 0 16px 0 rgba(60, 75, 93, 0.08);

    .menu-item__label,
    .menu-item__dot {
      opacity: 1;
    }
  }
}

@include media-breakpoint-up(lg) {
  .mobile-header {
    display: none;
  }
  .sidebar {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 80px;
    border-right: 1px solid #eee;
    background: var(--white);

    transition: width ease 0.2s;
    padding: 32px 0 16px;

    &:hover {
      width: 240px;
      box-shadow: 2px 0 16px 0 rgba(60, 75, 93, 0.08);

      .menu-item {
        width: 100%;
      }

      .menu-item__label,
      .menu-item__dot {
        opacity: 1;
      }
    }
  }
}

.tags-wrapper {
  position: relative;
}

.item-tag-wrapper {
  position: absolute;
  left: 86px;
  z-index: 10;
}
</style>
